<template>
  <div
    v-infinite-scroll="load"
    infinite-scroll-disabled="disabled"
    style="height: 400px;width: 100%;overflow:auto"
  >
    <el-card
      @click.native.stop="cardClick(item, index)"
      :class="{ noticePanel: item.active }"
      v-for="(item, index) in taskNoticeSource"
      :key="index"
    >
      <div style="float:right; cursor:pointer" @click="readRemind(item)">
        <el-tooltip :content="item.ISREAD ? '已读' : '未读'" placement="bottom" effect="light">
          <icon :iconClass="item.ISREAD ? 'yidu' : 'xin-copy'" iconStyle="readIcon"></icon>
        </el-tooltip>
      </div>
      <div class="detailPanel">
        <div class="nameImg">
          <icon :iconClass="getIcon(item.INFOTYPE)" iconStyle="avatarIcon"></icon>
        </div>
        <div>
          <div style="display:flex;flex-wrap: wrap;">
            <!-- <el-tooltip :content="'任务名:'.concat(item.LINKNAME)" placement="bottom" effect="light"> -->
            <el-link
              class="linkName"
              v-show="item.LINKNAME && item.LINKNAME.length > 0"
              :underline="false"
              @click.native.stop="openTaskDetail(item.LINKID)"
            >
              <span>【{{ item.LINKNAME }}】</span>
              <!-- {{item.LINKNAME.length>15?item.LINKNAME.substr(0,15).concat('...'):item.LINKNAME}}】 -->
            </el-link>
            <!-- </el-tooltip> -->
            <el-tooltip :content="item.NAME" placement="bottom" effect="light">
              <el-link class="title" @click="clickAddress(item)">
                {{
                item.NAME
                }}
              </el-link>
            </el-tooltip>
          </div>
          <el-tooltip :content="item.CONTENT" placement="bottom" effect="light">
            <div class="content">{{ item.CONTENT }}</div>
          </el-tooltip>
          <div class="createTime">{{ item.CREATETIME | timeFormater }}</div>
          <span class="reply" style="cursor:Pointer" @click="reply(item)">{{ item | btnNameFormat }}</span>
        </div>
      </div>
      <addComment
        v-show="showAddComment && item.active"
        style="margin:5px;"
        :replyData="replyData"
        @addComment="addSuccess"
        @cancelComment="cancelSuccess"
        :MainId="mainId"
        :Type="mainType"
      ></addComment>
    </el-card>
    <h3 v-if="loading">加载中...</h3>
    <h3 v-if="noMore">没有更多了</h3>
    <el-dialog
      title="修改任务关注度"
      append-to-body
      :visible.sync="taskRateDialogVisible"
      width="400px"
      center
    >
      <div style="display:flex;align-items: baseline;">
        <span style="font-size:16px;margin:0 10px">任务名称：</span>
        <span>{{ curItem == null ? "" : curItem.LINKNAME }}</span>
      </div>
      <div style="display:flex;align-items: baseline;margin-top:20px">
        <span style="font-size:16px;margin:0 10px">任务关注度：</span>
        <el-rate
          :max="3"
          class="taskRate"
          :icon-classes="iconClasses"
          void-icon-class="icon iconfont icon-guanzhu1"
          disabled-void-icon-class="icon iconfont icon-guanzhu1"
          v-model="taskRate"
        ></el-rate>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="taskRateDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="changeRate">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="评论" append-to-body :visible.sync="dialogVisible" width="60%">
      <div>
        <comment :MainId="mainId" :ShowLink="true" :Type="mainType"></comment>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  UpdateTaskMemberFocusDegree,
  GetTaskMemeber,
  GetUnReadRemind,
  GetCrisitismById,
} from "@/api/modules/basicData/task";
import addComment from "@/components/common/AddComment.vue";
import { getToken } from "@/util/auth";
import comment from "@/components/common/comment.vue";
import Vue from "vue";
import icon from "@/components/common/icon.vue";
const cookieUser = getToken();
export default {
  components: {
    comment,
    addComment,
    icon,
  },
  props: {
    taskNoticeSource: {
      type: Array,
      default: () => [],
    },
    taskCount: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    noMore() {
      return this.taskCount <= this.pageIndex * this.pageSize;
    },
    disabled() {
      return this.loading || this.noMore;
    },
  },
  data() {
    return {
      loading: false,
      showAddComment: false,
      replyData: {},
      dialogVisible: false,
      curItem: null,
      taskRateDialogVisible: false,
      taskRate: 0,
      iconClasses: [
        "icon iconfont icon-guanzhu2",
        "icon iconfont icon-guanzhu2",
        "icon iconfont icon-guanzhu2",
      ],

      mainId: "",
      mainType: "1",
      avatarArray: ["gongzuojilu2", "renwutixing", "chat"],
      pageIndex: 1,
      pageSize: 10,
    };
  },
  filters: {
    btnNameFormat: function (item) {
      return item == null
        ? ""
        : item.INFOTYPE == 102
        ? "回复"
        : item.INFOTYPE == 115
        ? "修改关注度"
        : "评论";
    },
    commentTypeFormat: function (val) {
      switch (val) {
        case 118:
          return "1";
        case 102:
          return "";
        default:
          return "0";
      }
    },
  },
  mounted() {
    this._getUnReadRemind();
  },
  methods: {
    load() {
      if (this.noMore) return;
      this.pageIndex++;
      this._getUnReadRemind();
    },
    _getUnReadRemind() {
      this.loading = true;
      GetUnReadRemind(this.pageIndex, this.pageSize, cookieUser.userId, 0)
        .then((result) => {
          console.log("GetUnReadRemind", result);
          if (result.Items) {
            this.loading = false;

            this.$emit("refershTaskSource", result);
          }
        })
        .catch((err) => console.log(err));
    },
    cancelSuccess() {
      this.showAddComment = false;
      this.replyData = {};
      this.mainId = "";
      this.mainType = "";
    },
    addSuccess() {
      this.cancelSuccess();
      this.readRemind(this.curItem);
    },
    readRemind(item) {
      this.$emit("readRemind", item);
    },
    cardClick(item, index) {
      this.curItem = item;
      console.log(item.INFOTYPE);
      console.log("cardClick", index);
      this.$nextTick(() => {
        this.taskNoticeSource.forEach((o) => {
          Vue.set(o, "active", false);
        });
        Vue.set(item, "active", true);
      });
    },
    changeRate() {
      // if (this.taskRate == 0) return;
      UpdateTaskMemberFocusDegree(
        this.mainId,
        cookieUser.userId,
        this.taskRate
      ).then((result) => {
        if (result === 1) {
          this.$message({
            type: "success",
            message: "修改成功。",
          });
          this.taskRateDialogVisible = false;
          this.readRemind(this.curItem);
        } else {
          this.$message({
            type: "error",
            message: "修改失败！",
          });
        }
      });
    },
    getIcon(infotype) {
      switch (infotype) {
        case 118:
          return this.avatarArray[0];
        case 102:
          return this.avatarArray[2];
        default:
          return this.avatarArray[1];
      }
    },
    reply(data) {
      switch (data.INFOTYPE) {
        case 102: //回复
          this.showAddComment = true;
          GetCrisitismById(data.RELATIONID).then((result) => {
            this.mainId = result.MAINID;
            this.mainType = result.MAINTYPE;
            this.replyData = result;
            console.log("Crisitism", result);
          });
          break;
        case 115: //修改关注度
          this.mainId = data.RELATIONID;
          this.mainType = 0;
          this.taskRate = 0;
          GetTaskMemeber(data.RELATIONID, false).then((result) => {
            if (result) {
              this.taskRate = result.find(
                (o) => o.USERID == cookieUser.userId
              ).FOCUSDEGREE;
              this.taskRateDialogVisible = true;
            }
          });

          break;
        default:
          //评论
          this.showAddComment = true;
          this.mainId = data.RELATIONID;
          this.mainType = data.INFOTYPE == 118 ? 1 : 0;
          //this.dialogVisible = true;
          break;
      }
    },
    openTaskDetail(val) {
      var taskId = val;
      if (val.indexOf(",") > 0) {
        var arr = val.split(",");
        taskId = arr[0];
        if (arr[1] == "1") {
          //评论是按逗号隔开的，id,type type=1是工作记录
          let url1 = `${location.href.substr(
            0,
            location.href.lastIndexOf("/")
          )}/recordinfo?recordid=${taskId}`;
          window.open(url1);
          return;
        }
      }
      let url = `${location.href.substr(
        0,
        location.href.lastIndexOf("/")
      )}/task-detailspage?taskid=${taskId}`;
      window.open(url);
    },
    clickAddress(item) {
      if (!item.ISREAD) {
        this.readRemind(item);
      }
      //判断infotype 118工作记录 102 评论
      switch (item.INFOTYPE) {
        case 118: //工作记录
          let url1 = `${location.href.substr(
            0,
            location.href.lastIndexOf("/")
          )}/recordinfo?recordid=${item.RELATIONID}`;
          window.open(url1);
          break;
        case 102: //评论
          GetCrisitismById(item.RELATIONID).then((result) => {
            if (result) {
              this.mainType = result.MAINTYPE;
              this.mainId = result.MAINID;
              this.dialogVisible = true;
            }
          });
          break;
        default:
          let url2 = `${location.href.substr(
            0,
            location.href.lastIndexOf("/")
          )}/task-detailspage?taskid=${item.RELATIONID}`;
          window.open(url2);
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.avatarIcon {
  width: 24px;
  height: 24px;
  margin-top: 10px;
}
.noticePanel {
  /* box-shadow: 0 2px 12px 0 rgb(32, 179, 45, 0.4); */
  border: 1px dashed gray;
}
.readIcon {
  width: 24px;
  height: 24px;
}

.detailPanel {
  display: flex;
  background: white /*beige*/;
  font-size: 14px;
}

.nameImg {
  color: #0c9cdb !important;
  margin-right: 5px;
}

.linkName {
  color: #0c9cdb !important;
}

.reply {
  margin-left: 15px;
  color: #0c9cdb !important;
}

.content {
  color: #20b32d;
  margin-left: 6px;
  max-width: 500px;
  overflow: hidden;
  /*超过部分不显示*/
  text-overflow: ellipsis;
  /*超过部分用点点表示*/
  white-space: nowrap;
  /*不换行*/
  text-align: left;
}

.createTime {
  font-size: 10px;
  color: #999;
  margin: 2px 6px;
  float: left;
}
</style>
